<div class="qr-reader-container">
  <app-onboarding-header
    [title]="'Escaneá el QR para pagar'"
    [subtitle]="''"
  ></app-onboarding-header>
  <div
    class="scanner-wrapper"
    [class.camera-active]="scannerEnabled"
    [class.camera-not-active]="!scannerEnabled"
  >
    <!-- Start Camera Button - Required for user interaction in iframes -->
    <div class="start-camera-overlay" *ngIf="!scannerEnabled">
      <div class="start-camera-content">
        <button (click)="startScanning()" [appButton]="'primary'" class="max-width" type="button">
          Escanear QR
        </button>
      </div>
    </div>
    <div *ngIf="scannerEnabled">
      <zxing-scanner
        [enable]="scannerEnabled"
        [device]="currentDevice"
        [formats]="allowedFormats"
        (camerasFound)="onCamerasFound($event)"
        (scanSuccess)="onScanSuccess($event)"
        (scanError)="onScanError($event)"
        (permissionResponse)="onPermissionResponse($event)"
        class="scanner"
      ></zxing-scanner>
    </div>
  </div>

  <div class="controls" *ngIf="hasDevices">
    <!-- <select 
      *ngIf="availableDevices.length > 1"
      [ngModel]="currentDevice?.deviceId"
      (ngModelChange)="onDeviceSelectChange($event)"
      class="device-select"
    >
      <option *ngFor="let device of availableDevices" [ngValue]="device.deviceId">
        {{ device.label || 'Camera ' + (availableDevices.indexOf(device) + 1) }}
      </option>
    </select> -->

    <!-- <button 
      *ngIf="!scannerEnabled" 
      (click)="startScanning()"
      class="scan-button"
    >
      Start Scanning
    </button>
    <button 
      *ngIf="scannerEnabled" 
      (click)="stopScanning()"
      class="scan-button"
    >
      Stop Scanning
    </button> -->
  </div>

  <div class="permission-message" *ngIf="!hasPermission && !hasDevices">
    <p>Camera permission is required to scan QR codes.</p>
    <p *ngIf="isInIframe" class="iframe-warning">
      If you're viewing this in an iframe, ensure the iframe has the
      <code>allow="camera"</code> attribute.
    </p>
  </div>
</div>
<app-onboarding-footer [showButton]="false"></app-onboarding-footer>
